import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionProps } from "@insite/mobius/Accordion";
import {
    AccordionSectionHeader,
    AccordionSectionPresentationProps,
    ManagedAccordionSection,
} from "@insite/mobius/AccordionSection";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Icon, { IconMemo, IconProps, IconWrapper } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Send from "@insite/mobius/Icons/ShoppingCart";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";
import { connect } from "react-redux";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { ProductCarouselIdState } from "@tsesco/Store/CheckoutReviewAndSubmitCarrierService/CheckoutReviewAndSubmitReducer";
import ListItem from "@insite/mobius/Lists";
import AccordionSection from "@insite/mobius/AccordionSection";
import Pdf from "@tsesco/Icons/Pdf";
import Download from "@tsesco/Icons/Download";

const enum fields {
    showDocuments = "showDocuments",
    showAttributes = "showAttributes",
    attributesPosition = "attributesPosition",
    documentsPosition = "documentsPosition",
    resourceWrapper = "resourceWrapper",
    descriptionWrapper = "descriptionWrapper",
}

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ProductCarouselIdState, ownProps: WidgetProps) => {
   return {
        relatedProducts: state?.ProductCarouselIdReducer?.widgetId === "" ? []:getProductsForProductInfoList(state, state?.ProductCarouselIdReducer?.widgetId),
 }
};
export interface ProductDetailsSpecificationsStyles {
    specificationsAccordion?: AccordionProps;
    specificationsAccordionSection?: AccordionSectionPresentationProps;
    documentsContainer?: GridContainerProps;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    attributeTypeWrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    attributeTypeWrapperNew?: InjectableCss;
    attributeTypeLabelTextNew?: TypographyPresentationProps;
    attributeTypeValuesTextNew?: TypographyPresentationProps;
    resourceWrapper?: InjectableCss;
    specificationWrapper?: InjectableCss;
    descriptionWrapper?: InjectableCss;
    resourceHeadingWrapper?: InjectableCss;
    specificationHeadingWrapper?: InjectableCss;
    descriptionHeadingWrapper?: InjectableCss;
    subDescriptionHeadingWrapper?: InjectableCss;
    htmlContentWrapper?: InjectableCss;
    productDetailAccordionSection?: AccordionSectionPresentationProps;
}

export const specificationsStyles: ProductDetailsSpecificationsStyles = {
    specificationsAccordion: {
        headingLevel: 2,
        css:css`
        margin-bottom: 10px;
        `
    },
    documentGridItem: {
        width: [12, 12, 4 , 4, 4],
    },
    documentIcon: {
        src: Pdf,
        color: "text.link",
        css: css`
            margin-right: 10px;
            height: 35px;
            width: 35px;
            svg{
                height: 35px;
                width: 35px;
            }
        `,
    },
    documentNameText: {
        css: css`
            vertical-align: super;
            font-size: 14px;
            font-weight: 600;
        `,
    },
    attributeTypeLabelText: {
        // weight: "bold",
        css: css`
            padding: 10px;
            border-right: 1px solid #e1dde2;
            font-size: 16px;
            font-family: "Roboto-Medium";
            line-height: 24px;
            word-break: break-word;
            color: ${getColor("text.accent")};
            border-top: 1px solid #e1dde2;
        `,
    },
    attributeTypeValuesText: {
        css: css`
            padding: 10px;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: ${getColor("text.accent")};
            border-top: 1px solid #e1dde2;
        `,
    },
    attributeTypeWrapper: {
        css: css`
            display: grid;
            grid-template-columns: 30% 70%;
            border-right: 1px solid #e1dde2;
            border-left: 1px solid #e1dde2;
            border-bottom: 1px solid #e1dde2;
            &:first-child {
                border-top: 1px solid #e1dde2;
            }
            /* margin-top: 20px; */
            &:nth-child(even) {
                background-color: #f1f1f1;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: 40% 60%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    attributeTypeLabelTextNew: {
        // weight: "bold",
        css: css`
            padding: 0px;
            width: 170px;
            font-size: 16px;
            font-family: "Roboto-bold";
            line-height: 24px;
            word-break: break-word;
            color: ${getColor("text.accent")};
        `,
    },
    attributeTypeValuesTextNew: {
        css: css`
            padding: 0px 10px;
            font-size: 15px;
            font-weight: 400;
            line-height: 24px;
        `,
    },
    attributeTypeWrapperNew: {
        css: css`
            display: flex;
            flex-direction: row;
            
        `,
    },
    resourceWrapper: {
        css: css`
            margin-top: 20px;
            > div {
                ${GridWrapper} {
                    ${GridOffset} {
                        ${GridItemStyle} {
                            ${StyledButton} {
                                ${TypographyStyle} {
                                    color: ${getColor("text.accent")};
                                    ${IconWrapper} {
                                        color: ${getColor("text.accent")};
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    specificationWrapper: {
        css: css`
            margin-top: 30px;
            padding-top: 10px;
        `,
    },
    descriptionWrapper: {
        css: css`
            > div {
                /* margin-top: 20px; */
                color: ${getColor("text.accent")};
                font-size: 16px !important;
                ul {
                    padding-left: 1rem !important;
                    color: ${getColor("text.accent")} !important;
                    font-size: 16px !important;
                    margin: 0px 0px 0px 20px !important;
                }
                li {
                    margin-bottom: 2px;
                }
                > html {
                    > body {
                        color: ${getColor("text.accent")};
                        font-size: 16px;
                    }
                }
            }
            strong {
                font-family: "Roboto-Bold";
            }
        `,
    },
    htmlContentWrapper: {
        css: css`
            body {
                color: ${getColor("text.accent")};
                font-size: 16px;
            }
            p:first-child {
                font-family: "Roboto-Bold";
            }
            p {
                margin-bottom: 2px;
                color: ${getColor("text.accent")};
                font-size: 16px !important;
                > strong {
                    font-family: "Roboto-Bold";
                }
            }
            strong {
                font-family: "Roboto-Bold";
            }
        `,
    },
    resourceHeadingWrapper: {
        css: css`
            font-size: 28px;
            color: ${getColor("primary")};
            font-family: "Roboto-Bold";
            background-color: ${getColor("common.border")};
            padding: 0.5rem;
            border-radius: 4px;
            display: block;
            margin-bottom: 1rem;
        `,
    },
    specificationHeadingWrapper: {
        css: css`
            font-size: 28px;
            color: ${getColor("primary")};
            font-family: "Roboto-Bold";
            background-color: ${getColor("common.border")};
            padding: 0.5rem;
            border-radius: 4px;
            display: block;
            margin-bottom: 1rem;
        `,
    },
    descriptionHeadingWrapper: {
        css: css`
            font-size: 28px;
            color: ${getColor("primary")};
            font-family: "Roboto-Bold";
            display: block;
            background-color: ${getColor("common.border")};
            padding: 0.5rem;
            border-radius: 4px;
            margin-bottom: 1rem;
            margin-top: 1rem;
        `,
    },
    subDescriptionHeadingWrapper: {
        css: css`
            font-size: 20px;
            color: #000000;
            font-family: "Roboto-bold";
            display: block;
            text-decoration: none;
            padding: 8px 0px;
        `,
    },
    productDetailAccordionSection: {
        panelProps:{
            css: css`
            border: none;
            `
        },
        headerProps:{
            css: css`
                 >button {
                  background: #F5F5F5;
                  padding: 5px 15px !important;
                border: 1px solid #D3D3D3;
                border-radius: 5px;
                &:focus{
                border: none !important;
                }
                  span{
                    margin: 0px;
                  }
                }
                  svg{
               color: #A22E31  
                }
            `
        },
        titleTypographyProps: {
            weight: "bold",
            css: css`
                font-size: 22px;
                color: #29241F;
                font-family: "Roboto-Bold";
                display: block;
                padding: 0.5rem;
                border-radius: 4px;
                margin:0px;
            `,
        },
    },
    documentLink:{
        css:css`
            width: 100%;
            box-sizing: border-box;
            border-radius: 10px;
            border: 1px solid transparent;
            &:hover{
               border: 1px solid #EBDFE6;
            }
            >span{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px;
                gap: 10px;
                >div{
                    display: flex;
                    align-items: center;
                    span{
                        color: #A22E31;
                    }
                }
            }
        `
    }
};

const styles = specificationsStyles;

const ProductDetailsSpecifications: React.FC<Props> = ({
    product: { brand, attributeTypes, documents, specifications, detail, content, manufacturerItem, productNumber },
    fields: { showDocuments, showAttributes, documentsPosition, attributesPosition },
    relatedProducts
}) => {
    const renderingDocuments = showDocuments && documents && documents.length > 0;
    const renderingAttributes = showAttributes && (brand || (attributeTypes && attributeTypes?.length > 0));
    const renderingSpecifications = specifications?.length !== 0 || content?.htmlContent !== "";
    const documentsFirst = documentsPosition === "first";
    const attributesFirst = attributesPosition === "first";

    if (!renderingDocuments && !renderingAttributes && !renderingSpecifications) {
        return null;
    }

    const hasValidHtmlContent = content?.htmlContent && !/<body>(&nbsp;|\s+)<\/body>/i.test(content.htmlContent);
    const showDescriptionHeading = renderingSpecifications && hasValidHtmlContent;

    const [resourcesSection, setResourcesSection] = React.useState(true);
    const documentsAccordion = renderingDocuments && (
        <Accordion
        headingLevel={2}
            {...styles.specificationsAccordion}
        >
        <AccordionSection
                key="a"
                {...styles.productDetailAccordionSection}
                title={translate(`Resources`)}
                expanded={resourcesSection}
                onTogglePanel={()=>{setResourcesSection(!resourcesSection)}}
            >
                <GridContainer {...styles.documentsContainer}>
                    {documents!.map(document => (
                        <GridItem key={document.id.toString()} {...styles.documentGridItem}>
                            <Link
                                href={document.filePath}
                                target="_new"
                                {...styles.documentLink}
                                data-test-selector={`productDetails_${document.id}`}
                            >
                                <StyledWrapper>
                                    <IconMemo {...styles.documentIcon} />
                                    <Typography {...styles.documentNameText}>
                                    {brand ? brand.name : ""} {manufacturerItem} {document.name}
                                    </Typography>
                                </StyledWrapper>
                                <Icon src={Download}/>
                            </Link>
                        </GridItem>
                    ))}
                </GridContainer>
            </AccordionSection>
        </Accordion>
        
    );

    const [specificationsAccordion, setSpecificationsAccordion] = React.useState(true);
    const attributesAccordion = renderingAttributes && (
    <Accordion
        headingLevel={2}
        {...styles.specificationsAccordion}
    >
        <AccordionSection
                key="a"
                {...styles.productDetailAccordionSection}
                title={translate("Specifications")}
                expanded={specificationsAccordion}
                onTogglePanel={()=>{setSpecificationsAccordion(!specificationsAccordion)}}
            >
                {brand && (
                    <StyledWrapper {...styles.attributeTypeWrapper}>
                        <Typography {...styles.attributeTypeLabelText}>{translate("Brand")}:&nbsp;</Typography>
                        <Typography {...styles.attributeTypeValuesText}>{brand.name}</Typography>
                    </StyledWrapper>
                )}
                {attributeTypes &&
                    attributeTypes.map(attributeType => (
                        <StyledWrapper {...styles.attributeTypeWrapper} key={attributeType.id.toString()}>
                            <Typography {...styles.attributeTypeLabelText}>
                                {attributeType.label || attributeType.name}:&nbsp;
                            </Typography>
                            <Typography {...styles.attributeTypeValuesText}>
                                {attributeType
                                    .attributeValues!.map(attributeValue => attributeValue.valueDisplay)
                                    .join(", ")}
                            </Typography>
                        </StyledWrapper>
                    ))}
                {detail?.unspsc && (
                    <StyledWrapper {...styles.attributeTypeWrapper}>
                        <Typography {...styles.attributeTypeLabelText}>{translate("UNSPSC")}:&nbsp;</Typography>
                        <Typography {...styles.attributeTypeValuesText}>{detail?.unspsc}</Typography>
                    </StyledWrapper>
                )}
                {detail?.upcCode && (
                    <StyledWrapper {...styles.attributeTypeWrapper}>
                        <Typography {...styles.attributeTypeLabelText}>{translate("UPC")}:&nbsp;</Typography>
                        <Typography {...styles.attributeTypeValuesText}>{detail?.upcCode}</Typography>
                    </StyledWrapper>
                )}
                {relatedProducts?.length ?  <StyledWrapper {...styles.attributeTypeWrapper}>
                        <Typography {...styles.attributeTypeLabelText}>{translate("Cross Sell Products")}:&nbsp;</Typography>
                        <Typography {...styles.attributeTypeValuesText}>
                           
                            {relatedProducts?.map((item,index)=>{
                            return <ListItem
                                    key={index}
                                    css={css`
                                        list-style: disc ;
                                        padding-top: 0.25rem;
                                    `}
                                >
                                    {item?.productTitle}
                                </ListItem>
                            })}
                            
                        </Typography>
                    </StyledWrapper>: null
                }
            </AccordionSection>
        </Accordion>
    );
    const [descriptionSection, setDescriptionSection] = React.useState(true);
    return (<>
        <Accordion
            headingLevel={2}
            {...styles.specificationsAccordion}
        >
            {documentsFirst && documentsAccordion}
            {showDescriptionHeading && (
                <AccordionSection
                key="a"
                {...styles.productDetailAccordionSection}
                title={translate(`${brand ? brand.name : ""} ${manufacturerItem} Description`)}
                expanded={descriptionSection}
                onTogglePanel={()=>{setDescriptionSection(!descriptionSection)}}
            >

                {content?.htmlContent && (
                    <Typography {...styles.htmlContentWrapper}>{parse(content.htmlContent, parserOptions)}</Typography>
                )}

                <GridContainer {...styles.specificationWrapper}>
                    {specifications && specifications?.length > 0 && 
                    <GridItem width={[12,12,6,6,6]} style={{borderRight:"1px solid #000000", paddingTop:"0px"}}>
                        <GridContainer>
                        {specifications?.map((specification, index) => {
                            return (
                            <GridItem width={12} style={{paddingBottom:"0px",paddingTop:"0px",marginTop:"0px"}} key={index}>
                                <StyledWrapper {...styles.descriptionWrapper}>
                                    <StyledWrapper>
                                        <Typography as="h3" {...styles.subDescriptionHeadingWrapper}>
                                           {manufacturerItem} {translate(specification.nameDisplay)}
                                        </Typography>
                                        <Typography {...styles.htmlContentWrapper}>
                                            {parse(transformContentHtml(specification.htmlContent), parserOptions)}
                                        </Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                                </GridItem>
                            );
                        })}
                        </GridContainer>
                    </GridItem>
                    }
                    <GridItem  width={[12,12,6,6,6]} style={{display:"flex", flexDirection:"column", paddingTop:"0px"}}>
                        <StyledWrapper {...styles.attributeTypeWrapperNew}>
                            <Typography {...styles.attributeTypeLabelTextNew}>{translate("SKU #")}</Typography>
                            <Typography {...styles.attributeTypeValuesTextNew}>{productNumber}</Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.attributeTypeWrapperNew}>
                            <Typography {...styles.attributeTypeLabelTextNew}>{translate("Part Number #")}</Typography>
                            <Typography {...styles.attributeTypeValuesTextNew}>{manufacturerItem}</Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.attributeTypeWrapperNew}>
                            <Typography {...styles.attributeTypeLabelTextNew}>{translate("UNSPSC")}</Typography>
                            <Typography {...styles.attributeTypeValuesTextNew}>{detail?.unspsc}</Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.attributeTypeWrapperNew}>
                            <Typography {...styles.attributeTypeLabelTextNew}>{translate("UPC")}</Typography>
                            <Typography {...styles.attributeTypeValuesTextNew}>{detail?.upcCode}</Typography>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
                
            </AccordionSection>
            )}
            </Accordion>
            {/* {content?.htmlContent && (
                                    <Typography {...styles.htmlContentWrapper}>
                                        {parse(content.htmlContent, parserOptions)}{" "}
                                    </Typography>
                                )} */}
         
            {!attributesFirst && attributesAccordion}
            {!documentsFirst && documentsAccordion}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsSpecifications)),
    definition: {
        displayName: "Specification",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showDocuments,
                displayName: "Show Documents",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.documentsPosition,
                displayName: "Documents Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                horizontal: true,
                fieldType: "General",
                sortOrder: 2,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showDocuments,
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.attributesPosition,
                displayName: "Attributes Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                fieldType: "General",
                horizontal: true,
                sortOrder: 4,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showAttributes,
            },
        ],
    },
};

export default widgetModule;
